/* global jQuery COMPONENTS */

COMPONENTS.ComponentSpecials = (function ($) {
  function ComponentSpecials () {
    this.$component = $('[data-ecs-component="component-specials"]')
    this.$anchors = $('a')
    this.$specialsOnLoad = $('[data-ecs-specials-on-load]')

    // Consent state for functionality-category cookies.
    // Default true when the cookie popup is not active (no consent system).
    this._functionalityConsented = !window._ecsCookiePopupEnabled
    // Pending cookie writes queued while awaiting consent: { name: { value, exdays } }
    this._pendingCookies = {}
  }

  /**
   * Get a cookie value by name
   */
  ComponentSpecials.prototype.getCookieValue = function (name) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) return parts.pop().split(';').shift()
    return null
  }

  /**
   * Write a cookie directly (no consent check — internal use only).
   */
  ComponentSpecials.prototype._writeCookie = function (name, value, exdays) {
    const d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/'
  }

  /**
   * Flush any cookies that were queued while waiting for consent.
   */
  ComponentSpecials.prototype._flushPendingCookies = function () {
    const component = this
    Object.keys(component._pendingCookies).forEach(function (name) {
      const p = component._pendingCookies[name]
      component._writeCookie(name, p.value, p.exdays)
      delete component._pendingCookies[name]
    })
  }

  /**
   * Set a cookie (site-wide path for reliability).
   * Defers the write if the cookie popup is active and functionality
   * cookies have not yet been accepted.
   */
  ComponentSpecials.prototype.setSpecialsCookie = function (name, value, exdays) {
    if (this._functionalityConsented) {
      this._writeCookie(name, value, exdays)
    } else {
      // Queue for when the user accepts functionality cookies
      this._pendingCookies[name] = { value: value, exdays: exdays }
    }
  }

  /**
   * Check if we should open the specials popup based on content hash and cookies
   */
  ComponentSpecials.prototype.shouldOpenSpecials = function ($element) {
    const currentHash = $element.data('specials-hash') || ''
    const ignoreCookies = $element.data('specials-ignore-cookies') === 1
    const homePageOnly = $element.data('specials-home-page-only') === 1
    const isHomePage = $('body').hasClass('property-home')

    // Check homepage restriction
    if (homePageOnly && !isHomePage) {
      return false
    }

    // If ignoring cookies, always show
    if (ignoreCookies) {
      return true
    }

    // Check cookie for this specific specials component
    const cookieName = '_ecs_components_special'
    const storedHash = this.getCookieValue(cookieName) || ''

    // If the content hash has changed (or no cookie exists), show and update cookie.
    // setSpecialsCookie will queue the write if consent has not been granted yet.
    if (storedHash !== currentHash) {
      this.setSpecialsCookie(cookieName, currentHash, 365)
      return true
    }

    return false
  }

  ComponentSpecials.prototype.init = function () {
    const component = this

    // When the cookie popup is active, track functionality consent state.
    // Both ecsCookieCheck (prior consent on page load) and ecsCookieAccept (fresh
    // accept) carry e.detail.cookie.categories. Flush any deferred writes.
    if (window._ecsCookiePopupEnabled) {
      const updateConsent = function (e) {
        const cats = (e && e.detail && e.detail.cookie && e.detail.cookie.categories)
          ? e.detail.cookie.categories
          : []
        if (cats.indexOf('functionality') !== -1) {
          component._functionalityConsented = true
          component._flushPendingCookies()
        }
      }
      document.addEventListener('ecsCookieAccept', updateConsent)
      document.addEventListener('ecsCookieCheck', updateConsent)
    }

    component.$anchors.each(function () {
      // Set a scoped reference to the anchor and href
      const $anchor = $(this)
      // If it doesn't have an href make sure to pass along an empty string
      // to the rest of the functiob below to prevent undefined errors
      const href = ($anchor.attr('href') ? $anchor.attr('href') : '')

      // Handle fancybox inline content
      if (href.includes('#components-specials')) {
        const link = href
        $anchor.attr('data-fancybox', '')
        $anchor.attr('data-src', link)
        $anchor.attr('href', 'javascript:;')
      }
    })

    if (component.$specialsOnLoad.length > 0) {
      // Function to open specials popup
      const openSpecials = function () {
        component.$specialsOnLoad.each(function () {
          const $specialsComponent = $(this)
          
          // Check if we should open this specials component
          if (component.shouldOpenSpecials($specialsComponent)) {
            $.fancybox.open({
              src: '#' + $specialsComponent.attr('id'),
              type: 'inline'
            })
          }
        })
      }

      // Wait for window load to ensure Fancybox is fully loaded
      if (document.readyState === 'complete' && typeof $.fancybox !== 'undefined') {
        openSpecials()
      } else {
        $(window).on('load', function () {
          openSpecials()
        })
      }
    }
  }

  return ComponentSpecials
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentSpecials = new COMPONENTS.ComponentSpecials()
  COMPONENTS.componentSpecials.init()
})
